<template>
  <div class="container-fluid">
    <div class="row">
      <b-col>
        <iq-card>
          <template v-slot:body class="pt-0">
            <b-row>
              <b-col>
                <b-row>
                  <b-col>
                    <h4 class="card-title">Search by</h4>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group class="mb-0">
                      <b-form-input
                        id="exampleInputText1"
                        type="text"
                        placeholder="enter contact name"
                        size="sm"
                        v-model="search"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col>
                    <h4 class="card-title">Filter by</h4>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group class="mb-0">
                      <b-form-select
                        plain
                        v-model="selectedCluster"
                        :options="clusterOptions"
                        size="sm"
                        class="mb-3"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null"
                            >select cluster</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group class="mb-0">
                      <b-form-select
                        plain
                        v-model="selectedCompany"
                        :options="companyOptions"
                        size="sm"
                        class="mb-3"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null"
                            >select company</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group class="mb-0">
                      <b-form-select
                        plain
                        v-model="selectedStageId"
                        :options="stageOptions"
                        size="sm"
                        class="mb-3"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null"
                            >select stage</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="!defaultSelectedCampaign">
                    <b-form-group class="mb-0">
                      <b-form-select
                        plain
                        v-model="selectedCampaign"
                        :options="campaignOptions"
                        size="sm"
                        class="mb-3"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null"
                            >select campaign</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="role === 'sales_manager'">
              <b-col>
                <b-row>
                  <b-col>
                    <h5>Filter by user</h5>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <v-select
                      multiple
                      :closeOnSelect="false"
                      v-model="selectedUserIds"
                      :reduce="(user) => user.id"
                      label="email"
                      :options="users"
                    ></v-select>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </div>
    <div class="row">
      <b-col>
        <iq-card>
          <template v-slot:body>
            <b-table
              hover
              responsive
              :items="items"
              :fields="fields"
              class="mb-0 table-borderless"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :busy="loading"
              data-cy="lead-table"
              sort-icon-left
            >
              <template #table-busy>
                <div class="text-center p-4" style="color: var(--iq-primary)">
                  <b-spinner class="align-middle mr-3"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(owner)="data">
                  <Avatar
                    :imageUrl="data.item.owner.avatar_url"
                    :backgroundColor="data.item.owner.avatar_color"
                    :initials="data.item.owner.initials"
                    :prettyName="data.item.owner.prettyName"
                    :small="true"
                  />
              </template>
              <template v-slot:cell(cluster)="data">
                <LeadClusterBadge :cluster="data.value" />
              </template>
              <template v-slot:cell(contact)="data">
                <router-link
                  v-if="$allowedRoute('leads.detail') && data.item.isOwner"
                  :to="{
                    path: `/leads/${data.item.id}`,
                  }"
                >
                  <b-button
                    variant="link"
                    style="color: var(--iq-primary)"
                    class="p-0 text-left"
                    data-cy="lead-detail-link"
                  >
                    {{ data.item.prettyName }}
                  </b-button>
                </router-link>
                <h6 v-else>
                  {{ data.item.prettyName }}
                </h6>
                <DeletedBadge :deletedAt="data.item.deletedAt" />
              </template>
              <template v-slot:cell(company)="data">
                <h6>{{ data.value ? data.value.name : "-" }}</h6>
              </template>
              <template v-slot:cell(next_best_action)="data">
                <h6>{{ data.value | notAvailable }}</h6>
              </template>
              <template v-slot:cell(products)="data">
                    <p
                      v-for="(p, idx) in data.item.products"
                      v-bind:key="idx"
                      style="margin-bottom: 0"
                      class="custom-data"
                    >
                      {{ p.name }}
                    </p>
              </template>
              <template v-slot:cell(stage_id)="data">
                <LeadStageBadge :stageId="data.value" />
              </template>
              <template v-slot:cell(campaign)="data">
                <h6>{{ data.value.name }}</h6>
              </template>
              <template v-slot:cell(last_activity)="data">
                <h6>{{ data.value | formatDate | notAvailable }}</h6>
              </template>
              <template v-slot:cell(priority_index)="data">
                <h6>{{ data.value }}</h6>
              </template>
              <template v-slot:cell(number_of_clicks)="data">
                <h6>{{ data.value }}</h6>
              </template>
              <template v-slot:cell(action)="data">
                <b-button
                  v-if="!data.item.deletedAt && $acl('leads.update.deleted_at') && data.item.isOwner"
                  @click="toDeleteItem = data.item.id"
                  variant="outline-danger"
                  size="sm"
                >
                  <i class="ri-delete-bin-line m-0"></i>
                </b-button>
              </template>
            </b-table>
          </template>
        </iq-card>
      </b-col>
    </div>
    <div class="row d-flex justify-content-center">
      <b-pagination
        value="3"
        size="md"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
      ></b-pagination>
    </div>
    <b-modal
      id="delete-modal"
      :visible="!!toDeleteItem"
      title="Delete lead"
      @hidden="toDeleteItem = null"
    >
      <p>
        Lead
        <strong>{{ toDeleteLead ? `${toDeleteLead.id}` : null }}</strong>
        will be deleted.
      </p>
      <p>Are you sure?</p>
      <template #modal-footer="{}">
        <b-button size="sm" variant="outline-dark" @click="toDeleteItem = null"
          >Cancel</b-button
        >
        <b-button size="sm" variant="danger" @click="deleteItem(toDeleteItem)"
          >Delete</b-button
        >
      </template>
    </b-modal>
  </div>
</template>
<script>
import { core } from "../../../config/pluginInit";
import DeletedBadge from "../Components/DeletedBadge";
import gql from "graphql-tag";
import LeadStageBadge from "../Components/LeadStageBadge";
import LeadClusterBadge from "../Components/LeadClusterBadge";
import IqCard from "../../../components/core/cards/iq-card.vue";
import { getAccountSync } from "../../../Utils/account";
import {getOwnerData, prettyName} from "../../../Utils/getOwnerData";
import Avatar from "./Avatar.vue";

const LIST_LEADS = gql`
  query listLeads(
    $where: leads_bool_exp!
    $order_by: [leads_order_by!]
    $limit: Int!
    $offset: Int!
  ) {
    leads_aggregate(order_by: $order_by, where: $where) {
      aggregate {
        totalCount: count
      }
    }
    leads(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
      id
      stage_id
      cluster
      priority_index
      number_of_clicks
      contact {
        id
        first_name
        last_name
        email
        company {
          id
          name
        }
      }
      deal_value
      campaign {
        id
        name
      }
      next_best_action {
        id
        name
      }
      lead_product_groups {
        id
        product_group {
          name
        }
      }
      last_activity
      owner {
        id
        first_name
        last_name
        email
        avatar_url
        avatar_color
      }
    }
  }
`;
const LIST_COMPANIES = gql`
  query listCompanies {
    companies {
      id
      name
    }
  }
`;
const LIST_CAMPAIGNS = gql`
  query listCampaigns {
    campaigns {
      id
      name
    }
  }
`;
const DELETE_LEAD = gql`
  mutation deleteLead($id: uuid!) {
    update_leads_by_pk(pk_columns: { id: $id }, _set: { deleted_at: "now()" }) {
      id
    }
  }
`;
const LIST_AVAILABLE_USERS = gql`
  query getMySalesPersons($adminId: uuid!){
    users (
      where: {
        role: {
          _eq: sales_person
        }
        organizations: {
          organization: {
            admin_id: {
              _eq: $adminId
            }
          }
        }
      }
    ){
      id
      email
      first_name
      last_name
    }
  }
`;

export default {
  name: "LeadsTable",
  components: {
    LeadStageBadge,
    LeadClusterBadge,
    IqCard,
    DeletedBadge,
    Avatar
  },
  props: {
    defaultSelectedCampaign: String
  },
  data() {
    return {
      sortBy: "priority_index",
      sortDesc: true,
      leads: [],
      search: "",
      rows: null,
      perPage: 100,
      currentPage: 1,
      error: false,
      loading: false,
      selectedCluster: null,
      selectedStageId: null,
      selectedCompany: null,
      selectedCampaign: null,
      role: getAccountSync()?.defaultRole,
      userId: getAccountSync()?.userId,
      fields: [
        { key: "owner", label: "Owner", sortable: true },
        { key: "cluster", label: "Cluster", sortable: true },
        { key: "contact", label: "Contact", sortable: false },
        { key: "company", label: "Company", sortable: false },
        { key: "next_best_action", label: "NBA", sortable: false },
        { key: "products", label: "Products", sortable: false },
        { key: "stage_id", label: "Stage", sortable: true },
        { key: "campaign", label: "Campaign", sortable: false },
        { key: "last_activity", label: "Last Activity", sortable: true },
        { key: "priority_index", label: "Priority Index", sortable: true },
        { key: "number_of_clicks", label: "Clicks", sortable: true },
        { key: "action", label: "Action", sortable: false }
      ],
      clusterOptions: [
        { value: "HOT", text: "Hot" },
        { value: "COLD", text: "Cold" }
      ],
      stageOptions: [
        { value: 100, text: "Qualified" },
        { value: 200, text: "Contacted" },
        { value: 300, text: "Met" },
        { value: 400, text: "Negotiating" },
        { value: 500, text: "Won" },
        { value: 0, text: "None" }
      ],
      toDeleteItem: null,
      selectedUserIds: []
    };
  },
  apollo: {
    leads: {
      query: LIST_LEADS,
      fetchPolicy: "no-cache",
      variables() {
        const vars = {
          where: {},
          // pagination
          limit: this.perPage,
          offset: this.currentPage * this.perPage - this.perPage
        };

        // sorting
        if (this.sortBy !== "") {
          vars.order_by = {
            [this.sortBy]: this.sortDesc ? "desc" : "asc"
          };
        }

        // filter
        const whereAttributes = [];
        if (this.search) {
          whereAttributes.push({
            contact: {
              _or: [
                {
                  first_name: {
                    _ilike: `%${this.search}%`
                  }
                },
                {
                  last_name: {
                    _ilike: `%${this.search}%`
                  }
                }
              ]
            }
          });
        }
        if (this.selectedCluster) {
          whereAttributes.push({
            cluster: {
              _eq: this.selectedCluster
            }
          });
        }
        if (this.selectedStageId !== null) {
          whereAttributes.push({
            stage_id: {
              _eq: this.selectedStageId
            }
          });
        }
        if (this.defaultSelectedCampaign) {
          whereAttributes.push({
            campaign_id: {
              _eq: this.defaultSelectedCampaign
            }
          });
        }
        if (this.selectedCampaign) {
          whereAttributes.push({
            campaign_id: {
              _eq: this.selectedCampaign
            }
          });
        }

        if (this.selectedCompany) {
          whereAttributes.push({
            contact: {
              company_id: {
                _eq: this.selectedCompany
              }
            }
          });
        }
        if (this.selectedUserIds.length > 0) {
          whereAttributes.push({
            owner_id: {
              _in: this.selectedUserIds
            }
          });
        }

        if (whereAttributes.length > 0) {
          vars.where = {
            _and: whereAttributes
          };
        }

        // // default sort by PX
        // if (!vars.order_by) {
        //   vars.order_by = {};
        // }
        // vars.order_by["priority_index"] = "desc";
        return vars;
      },

      result({ data, loading, networkStatus }) {
        if (!loading) {
          this.rows = data.leads_aggregate.aggregate.totalCount;
        }
      }
    },
    companies: {
      query: LIST_COMPANIES
    },
    campaigns: {
      query: LIST_CAMPAIGNS
    },
    users: {
      query: LIST_AVAILABLE_USERS,
      variables(){
        return {
          adminId: getAccountSync()?.userId,
        }
      }
    }
  },
  computed: {
    items() {
      const d = this.leads.map(lead => {
        return {
          id: lead.id,
          cluster: lead.cluster,
          contact: lead.contact,
          company: lead.contact.company,
          stage_id: lead.stage_id,
          campaign: lead.campaign,
          last_activity: lead.last_activity,
          priority_index: lead.priority_index,
          number_of_clicks: lead.number_of_clicks,
          next_best_action: lead.next_best_action?.name,
          products: lead.lead_product_groups.map(i => ({
            id: i.id,
            name: i.product_group.name
          })),
          owner: getOwnerData(lead.owner),
          prettyName: prettyName(
            lead.contact.first_name,
            lead.contact.last_name,
            lead.contact.email,
          ),
          isOwner: lead.owner.id === this.userId
        };
      });
      return d;
    },
    companyOptions() {
      if (!this.companies) {
        return [];
      }
      return this.companies.map(i => ({
        value: i.id,
        text: i.name
      }));
    },
    campaignOptions() {
      if (!this.campaigns) {
        return [];
      }
      return this.campaigns.map(i => ({
        value: i.id,
        text: i.name
      }));
    },
    toDeleteLead() {
      if (!this.toDeleteItem) {
        return null;
      }
      const l = this.items.find(i => i.id === this.toDeleteItem);
      if (!l) {
        return null;
      }
      return l;
    }
  },
  mounted() {
    core.index();
  },
  methods: {
    async deleteItem(id) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_LEAD,
          variables: {
            id
          }
        });
        this.$toast.success(`Lead deleted`);
        this.toDeleteItem = null;
      } catch (error) {
        this.$toast.error(`Failed to delete lead : ${error.message}`);
      }
    }
  }
};
</script>
<style scoped>
.custom-data {
  font-size: 10px !important;
}
</style>